"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class WalletServiceLive {
    createWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post("/wallet");
            return response.data;
        });
    }
    registerPayId(walletId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/register-pay-id`);
            return response.data;
        });
    }
    getWallet(walletId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/wallet/${walletId}`);
            return response.data;
        });
    }
    linkExternalBankAccount(walletId, bankAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/link-external-bank-account`, bankAccount);
            return response.data;
        });
    }
    deleteBankAccount(walletId, bankAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/delete-bank-account`, bankAccount);
            return response.data;
        });
    }
    withdraw(walletId, withdrawBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/withdraw`, withdrawBody);
            return response.data;
        });
    }
    completeExternalBankAccountVerification(walletId, verification) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/complete-external-bank-account-verification`, verification);
            return response.data;
        });
    }
    getWalletTransactions(walletId, sortBy, sortOrder, page, rowsPerPage) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/wallet/${walletId}/transactions`, {
                sortBy,
                sortOrder,
                page,
                rowsPerPage,
            });
            return response.data;
        });
    }
}
exports.WalletServiceLive = WalletServiceLive;
//# sourceMappingURL=WalletServiceLive.js.map